import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ExamRolViewNew from './examRolViewNew';
import { Creators as getExamsRoleByStudentActions } from '@/domain/useCases/getExamsRoleByStudent';

const ExamRolController = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const handlerBack = () => history.push('/inicio');

  const {
    data: examsRoleData,
    isLoading,
    error
  } = useSelector((state: any) => state.examsRoleByStudent);

  useEffect(() => {
    if (examsRoleData || isLoading) return;
    dispatch(getExamsRoleByStudentActions.getExamsRoleByStudent());
  }, []);

  return (
    <ExamRolViewNew
      isLoadingData={isLoading}
      handlerBack={handlerBack}
      dataExamRol={examsRoleData}
      hasError={error}
    />
  );
};

export default ExamRolController;
